import request from '@/api/request'

export default {
  /**
   * Retorna dados para autorização da conta no Shopee.
   *
   * @returns {Promise<*>}
   */
  async getAuthorization () {
    return (await request.get(`module/action/marketplace/shopee/account/getAuthorization`)).data
  },
  /**
   * Adiciona a conta no placemarket
   *
   * @param code
   * @param shopId
   * @returns {Promise<*>}
   */
  async addAccount (code, shopId) {
    return (await request.get(`module/action/marketplace/shopee/account/add/${code}/${shopId}`)).data
  },
  /**
   * Retorna as marcas do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getBrands (type, identifier) {
    return (await request.get(`module/action/marketplace/shopee/brand`)).data
  },
  /**
   * Busca as contas cadastradas conforme filtros
   *
   * @param options
   * @returns {Promise<*>}
   */
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/shopee/account/index`, {
      params: options
    })).data
  },
  /**
   * Retorna os dados da conta, buscando pelo shopId.
   *
   * @param shopId
   * @returns {Promise<*>}
   */
  async getAccountByShopId (shopId) {
    return (await request.get(`module/action/marketplace/shopee/account/retrieveByShopId/${shopId}`)).data
  },
  /**
   * Atualiza o CNPJ da conta e faz backfill nos pedidos capturados.
   *
   * @param {String} shopId
   * @param {String} cnpj
   * @returns {Promise<Object>}
   */
  async updateCnpj (shopId, cnpj) {
    return (await request.get(`module/action/marketplace/shopee/account/updateCnpj/${shopId}/${cnpj}`)).data
  },
  /**
   * Deleta uma conta de acordo com o shopId.
   *
   * @param shopId
   * @returns {Promise<*>}
   */
  async deleteAccountByShopId (shopId) {
    return (await request.get(`module/action/marketplace/shopee/account/deleteAccountByShopId/${shopId}`)).data
  },
  /**
   * Retorna as cores do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getColors () {
    return (await request.get(`module/action/marketplace/shopee/color`)).data
  },
  /**
   * Retorna os tamanhos do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getSizes () {
    return (await request.get(`module/action/marketplace/shopee/size`)).data
  },
  /**
   * Salva produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async saveProduct (product) {
    return (await request.post(`module/action/marketplace/shopee/product/save`, product)).data
  },
  /**
   * Atualiza o produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async updateProduct (product) {
    return (await request.post(`module/action/marketplace/shopee/product/edit`, product)).data
  },
  /**
   * Atualiza o preço do produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async updateProductPrice (product) {
    return (await request.post(`module/action/marketplace/shopee/product/edit_price`, product)).data
  },
  /**
   * Sincroniza pedido por tipo e identificador do módulo e conta do shopee.
   *
   * @param {String} type
   * @param {String} identifier
   * @param {String} code
   * @param {String} account
   * @returns {Object} Pedido sincronizado
   */
  async syncOrder (type, identifier, code, account) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}`, {
      headers: {
        'Shopee-Account': account
      }
    })).data
  },
  /**
   * Busca um produto pelo código do ML.
   *
   * @param {String} code
   * @param {String} account
   * @returns {Object} anúncio
   */
  async retrieveByCode (code, account) {
    return (await request.get(`module/action/marketplace/shopee/product/retrieve_by_code/${code}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Atualiza informações pendentes do pedido da modalidade entrega a combinar.
   *
   * @param {Object} order
   * @returns {Object} Pedido atualizado
   */
  async updateOrderPendingInformations (order) {
    return (await request.post(`module/action/marketplace/shopee/order/update_informations`, order)).data
  },
  /**
   * Retorna as categorias do Shopee.
   *
   * @param {Object} account
   *
   * @returns {Promise.<Object>}
   */
  async getCategories (account) {
    return (await request.get(`module/action/marketplace/shopee/category/retrieve`, {
      headers: {
        'Shopee-Account': account
      }
    })).data
  },
  /**
   * Retorna as formas de envio do Shopee.
   *
   * @param {Object} account
   *
   * @returns {Promise.<Object>}
   */
  async getShippingMethods (account) {
    return (await request.get(`module/action/marketplace/shopee/shipping/retrieve`, {
      headers: {
        'Shopee-Account': account
      }
    })).data
  },
  /**
   * Retorna as categorias do Shopee.
   *
   * @param {Object} account
   * @param {String} code
   *
   * @returns {Promise.<Object>}
   */
  async getAttributes (account, code) {
    return (await request.get(`module/action/marketplace/shopee/category/attributes/${code}`, {
      headers: {
        'Shopee-Account': account
      }
    })).data
  },
  /**
   * Retorna as tabelas de medidas (size chart) de uma categoria do Shopee.
   *
   * @param {Object} account
   * @param {String} code
   *
   * @returns {Promise.<Array>}
   */
  async getSizeCharts (account, code) {
    return (await request.get(`module/action/marketplace/shopee/category/size_charts/${code}`, {
      headers: {
        'Shopee-Account': account
      }
    })).data
  },
  /**
   * Atualiza o status da conta do Shopee.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/shopee/account/active/${identifier}`)).data
    }
    return (await request.get(`module/action/marketplace/shopee/account/inactive/${identifier}`)).data
  },
  /**
   * Renova o token de uma conta.
   *
   * @param {String} identifier
   * @returns {Object}
   */
  async refreshToken (identifier) {
    return (await request.get(`module/action/marketplace/shopee/account/refresh_token/${identifier}`)).data
  },
  /**
   * Retorna os dados da conta, buscando pelo código de autorização.
   *
   * @param code
   * @param shopId
   * @returns {Promise<*>}
   */
  async getAccount (code, shopId) {
    return (await request.get(`module/action/marketplace/shopee/account/retrieve/${code}/${shopId}`)).data
  },
  /**
   * Retorna os dados da conta, buscando pelo código de autorização.
   *
   * @param code
   * @param shopId
   * @returns {Promise<*>}
   */
  async getAccountsProductLimits () {
    return (await request.get(`module/action/marketplace/shopee/account/retrieveAccountProductLimit`)).data
  },
  /**
   * Remove o vínculo do anúncio com o hub.
   *
   * @param String id
   * @returns {Promise<*>}
   */
  async deleteProduct (id) {
    return (await request.get(`module/action/marketplace/shopee/product/delete/${id}`)).data
  },
  /**
   * Ativa um anúncio.
   *
   * @param id
   * @param account
   * @return {Promise<*>}
   */
  async activateAnnouncement (id, account) {
    return (await request.get(`module/action/marketplace/shopee/product/activate/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Pausa um anúncio.
   *
   * @param id
   * @param account
   * @return {Promise<*>}
   */
  async pauseAnnouncement (id, account) {
    return (await request.get(`module/action/marketplace/shopee/product/pause/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/shopee/index.js